export const PFC_NEWLINE_TOKEN = '__PFC_NL__'

export const decodePerlingoNewlines = (value: string): string => {
  if (!value) return ''

  let next = String(value)

  // Preferred encoding (WP-safe, no backslashes).
  if (next.includes(PFC_NEWLINE_TOKEN)) {
    next = next.split(PFC_NEWLINE_TOKEN).join('\n')
  }

  // Legacy/defensive: some backends may return newlines as the two-character sequence "\\n".
  if (!next.includes('\n') && /\\r\\n|\\n/.test(next)) {
    next = next.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n')
  }

  return next
}

export const encodePerlingoNewlinesForWp = (value: string): string => {
  if (!value) return ''

  // Normalize Windows newlines first.
  const normalized = String(value).replace(/\r\n/g, '\n')
  if (!normalized.includes('\n')) return normalized

  // Encode real newlines into a token so WordPress sanitization can't strip backslashes.
  return normalized.split('\n').join(PFC_NEWLINE_TOKEN)
}
